/**
 * Named corporate colors of the visit history, typed once. Every other
 * palette (states, cuts, materials, vans) composes these constants instead of
 * re-typing hex literals. Always lowercase hex.
 */
export const NAVY = '#012f86';
export const TEAL = '#00c0b3';
export const SLATE_BLUE = '#3b82f6';
export const SOFT_PURPLE = '#8b5cf6';
export const MUTED_TEAL = '#0d9488';
export const SLATE_DARK = '#0f172a';
export const STEEL_GRAY = '#64748b';
export const AMBER = '#f59e0b';
export const CORAL = '#f43f5e';
export const SAGE = '#10b981';
export const WHITE = '#ffffff';
